import React, { createContext, Component } from 'react';
import PropTypes from 'prop-types';
import ScrollMagic from 'scrollmagic';
import { scrollMagicSceneFactory } from '../../helpers/scrollMagicSceneFactory';
import { triggerHooks } from '../../helpers/triggerHooks';

export const ScrollAnimationsContext = createContext();

export class ScrollingAnimationsProvider extends Component {
  constructor(props) {
    super(props);

    this.controller = new ScrollMagic.Controller();
    this.withSmokersScene = scrollMagicSceneFactory(
      'withSmokers',
      triggerHooks.BOTTOM,
      '100%',
      this.controller,
      this.updateProgress
    );
    this.withSmokersGapScene = scrollMagicSceneFactory(
      'withSmokersGapSection',
      triggerHooks.BOTTOM,
      '50%',
      this.controller,
      this.updateProgress
    );
    this.simpleScene = scrollMagicSceneFactory(
      'simple',
      triggerHooks.BOTTOM,
      '100%',
      this.controller,
      this.updateProgress
    );
    this.simpleGapScene = scrollMagicSceneFactory(
      'simpleGapSection',
      triggerHooks.BOTTOM,
      '100%',
      this.controller,
      this.updateProgress
    );
    this.cleanScene = scrollMagicSceneFactory(
      'clean',
      triggerHooks.BOTTOM,
      '100%',
      this.controller,
      this.updateProgress
    );
    this.cleanGapScene = scrollMagicSceneFactory(
      'cleanGapSection',
      triggerHooks.BOTTOM,
      '135%',
      this.controller,
      this.updateProgress
    );
    this.satisfyingScene = scrollMagicSceneFactory(
      'satisfying',
      triggerHooks.BOTTOM,
      '100%',
      this.controller,
      this.updateProgress
    );
    this.chargesAnywhereScene = scrollMagicSceneFactory(
      'chargesAnywhereScene',
      triggerHooks.TOP,
      '100%',
      this.controller,
      this.updateProgress
    );
    this.chargesAnywhereGapScene = scrollMagicSceneFactory(
      'chargesAnywhereGap',
      triggerHooks.TOP,
      '100%',
      this.controller,
      this.updateProgress
    );
  }

  // This callback is necessary to ensure each the state of each scene is updated when their progress changes
  updateProgress = () => {
    this.setState({
      ...this.state,
    });
  };

  render() {
    const contextValue = {
      ...this.state,
      cleanScene: this.cleanScene,
      cleanGapScene: this.cleanGapScene,
      simpleGapScene: this.simpleGapScene,
      simpleScene: this.simpleScene,
      withSmokersGapScene: this.withSmokersGapScene,
      withSmokersScene: this.withSmokersScene,
      satisfyingScene: this.satisfyingScene,
      satisfyingGapScene: this.satisfyingGapScene,
      chargesAnywhereScene: this.chargesAnywhereScene,
      chargesAnywhereGapScene: this.chargesAnywhereGapScene,
    };

    return (
      <ScrollAnimationsContext.Provider value={contextValue}>
        {this.props.children}
      </ScrollAnimationsContext.Provider>
    );
  }
}

ScrollingAnimationsProvider.propTypes = {
  children: PropTypes.element,
};
